const dev = true;

export const BASE_URL = dev ?
"https://cijianlink.com"
:
"https://cijianlink.com"
export const API_SERVER =  `${BASE_URL}/api/`;


export const WX_REDIRECT = `${BASE_URL}/api/openapi/weixin/toPay`

export const WX_APPID = 'wxe60cce306c683fa9';

